import { useEffect, useState } from "react";

export const useDebouncedValue = <T>(value: T, delayMs: number): T => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const agendamento = setTimeout(() => setDebounced(value), delayMs);

    return () => clearTimeout(agendamento);
  }, [value, delayMs]);

  return debounced;
};
